import React, { useEffect, useState, useCallback } from "react";
import { ApiRequestNoLoder } from "../services/api";

const btn = { color: "#fff", textDecoration: "none", padding: "6px 12px", borderRadius: 6, fontSize: 13, fontWeight: 600, display: "inline-block", border: "none", cursor: "pointer" };
const digits = (p) => (p || "").replace(/\D/g, "").slice(-10);
const wa = (p) => `https://wa.me/91${digits(p)}`;
const tel = (p) => `tel:+91${digits(p)}`;

const KINDS = {
  // biodata / documents
  biodata_ask: { label: "Biodata ask", color: "#8b5cf6", emoji: "📄" },
  biodata_request: { label: "Biodata request", color: "#8b5cf6", emoji: "📄" },
  photo_request: { label: "Photo request", color: "#a855f7", emoji: "📷" },
  gotra_collect: { label: "Collect gotra", color: "#7c3aed", emoji: "📝" },
  // interest / warm leads
  hot_lead: { label: "Mutual YES", color: "#f59e0b", emoji: "💛" },
  hot_lead_interest: { label: "Interest", color: "#f59e0b", emoji: "💛" },
  haan_interest_call: { label: "Interest call", color: "#f59e0b", emoji: "📞" },
  gate_warm_lead: { label: "Warm lead", color: "#eab308", emoji: "🔥" },
  sweep_warm_lead: { label: "Warm lead", color: "#eab308", emoji: "🔥" },
  // calls / alerts / contact
  contact_request: { label: "Contact request", color: "#0ea5e9", emoji: "📞" },
  call_outcome: { label: "Call outcome", color: "#0284c7", emoji: "📞" },
  team_alert: { label: "Team alert", color: "#ef4444", emoji: "🔔" },
  appointment_time: { label: "Appointment", color: "#06b6d4", emoji: "📅" },
  // escalations / complaints / frustration
  escalation: { label: "Escalation", color: "#ef4444", emoji: "⚠️" },
  match_quality_complaint: { label: "Match complaint", color: "#dc2626", emoji: "⚠️" },
  campaign_complaint: { label: "Complaint", color: "#dc2626", emoji: "⚠️" },
  sweep_complaint: { label: "Complaint", color: "#dc2626", emoji: "⚠️" },
  gate_complaint: { label: "Complaint", color: "#dc2626", emoji: "⚠️" },
  gate_frustration: { label: "Frustration", color: "#f97316", emoji: "😤" },
  sweep_frustration: { label: "Frustration", color: "#f97316", emoji: "😤" },
  // rejection / churn
  rejection_reason: { label: "Rejection reason", color: "#f97316", emoji: "🚫" },
  sweep_churn_risk: { label: "Churn risk", color: "#e11d48", emoji: "📉" },
  gate_churn_risk: { label: "Churn risk", color: "#e11d48", emoji: "📉" },
  // preference
  preference: { label: "Preference", color: "#10b981", emoji: "🎯" },
  campaign_preference: { label: "Preference", color: "#10b981", emoji: "🎯" },
  // payments
  payment_pending: { label: "Payment pending", color: "#d97706", emoji: "💳" },
  payment_failed: { label: "Payment failed", color: "#dc2626", emoji: "💳" },
  payment_followup: { label: "Payment follow-up", color: "#d97706", emoji: "💳" },
  // engagement / exit
  campaign_engaged: { label: "Engaged", color: "#ec4899", emoji: "🎉" },
  sweep_engaged_leaving: { label: "Engaged (leaving)", color: "#ec4899", emoji: "🎉" },
  engaged_deactivated: { label: "Engaged ✓ off", color: "#ec4899", emoji: "🎉" },
  // campaigns / winback
  winback: { label: "Win-back", color: "#6366f1", emoji: "🔄" },
  campaign_start: { label: "Campaign reply", color: "#14b8a6", emoji: "▶️" },
  usa_campaign_reply: { label: "USA campaign", color: "#14b8a6", emoji: "🌎" },
};

function StatusChip({ status }) {
  const m = {
    read: { t: "👁 Seen by team", c: "#16a34a" },
    delivered: { t: "✓✓ Delivered, not seen yet", c: "#d97706" },
    sent: { t: "→ Sent (not delivered)", c: "#9ca3af" },
    failed: { t: "⚠️ Failed to deliver", c: "#dc2626" },
  };
  const s = m[status] || { t: "⚠️ Not alerted", c: "#dc2626" };
  return <span style={{ color: s.c, fontWeight: 600 }}>{s.t}</span>;
}

function Stat({ n, label, color }) {
  return (
    <div style={{ flex: 1, minWidth: 130, background: "#fff", border: "1px solid #e5e7eb", borderTop: `4px solid ${color}`, borderRadius: 10, padding: "12px 14px" }}>
      <div style={{ fontSize: 28, fontWeight: 800, color }}>{n ?? 0}</div>
      <div style={{ fontSize: 12, color: "#6b7280" }}>{label}</div>
    </div>
  );
}

// Open a member/candidate profile in a new tab (admin profile route). Falls back to plain
// text when we don't have an id to link to.
function NameLink({ id, children }) {
  if (!id) return <>{children}</>;
  return (
    <a href={`/user-details/${id}`} target="_blank" rel="noreferrer" title="Open profile in a new tab"
       style={{ color: "#2563eb", textDecoration: "none", cursor: "pointer" }}>{children} ↗</a>
  );
}

function Item({ it, onAck, onNote, busy }) {
  const k = KINDS[it.kind] || { label: it.kind, color: "#6b7280", emoji: "•" };
  const done = it.acknowledged;
  const overdue = !done && it.age_hours != null && it.age_hours >= 24;
  const age = it.age_hours == null ? "" : it.age_hours < 1 ? "just now" : it.age_hours < 24 ? `${Math.round(it.age_hours)}h ago` : `${Math.round(it.age_hours / 24)}d ago`;

  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  // Save the typed note to this member's admin notes (tagged with the logged-in admin server-side).
  // alsoDone=true then marks the item done. An empty note + alsoDone just marks done.
  const saveNote = async (alsoDone) => {
    const text = note.trim();
    setSaving(true);
    try {
      if (text) {
        await onNote(it.user_id, text);
        setNote(""); setSaved(true); setTimeout(() => setSaved(false), 2500);
      }
      if (alsoDone) await onAck(it.id, false);
    } catch (e) {
      alert((e && e.message) || "Could not save note");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ border: overdue ? "2px solid #ef4444" : done ? "1px solid #d1fae5" : "1px solid #e5e7eb", background: done ? "#f0fdf4" : overdue ? "#fef2f2" : "#fff", borderRadius: 12, padding: 14, marginBottom: 10 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
        <span style={{ background: k.color, color: "#fff", fontSize: 12, fontWeight: 700, padding: "3px 10px", borderRadius: 20 }}>{k.emoji} {k.label}</span>
        <span style={{ fontSize: 12, color: overdue ? "#ef4444" : "#9ca3af", fontWeight: overdue ? 700 : 400 }}>
          {overdue ? "⏰ overdue · " : ""}{age}
        </span>
      </div>

      <div style={{ marginTop: 8, fontSize: 15, fontWeight: 700 }}>
        <NameLink id={it.user_id}>{it.user_name || it.user_phone || it.user_id || "Member"}</NameLink>
        {it.candidate_name ? <span style={{ fontWeight: 400, color: "#6b7280" }}> {"→"} <NameLink id={it.candidate_id}>{it.candidate_name}</NameLink></span> : null}
      </div>
      {it.detail ? <div style={{ fontSize: 13, color: "#374151", marginTop: 2 }}>{it.detail}</div> : null}

      <div style={{ fontSize: 12, color: "#6b7280", marginTop: 6 }}>
        {it.assigned_to ? <>owner: <b>{it.assigned_to}</b></> : "unassigned"}
        {(it.kind === "contact_request" || it.kind === "biodata_ask" || it.kind === "escalation")
          ? <>{"  ·  "}<StatusChip status={it.alert_status} /></>
          : null}
        {done && it.acknowledged_by_username ? <>{"  ·  done by "}<b>{it.acknowledged_by_username}</b></> : null}
      </div>

      {!done ? (
        <div style={{ marginTop: 10 }}>
          <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2}
            placeholder="Add a note / call outcome — saves to this member's admin notes"
            style={{ width: "100%", boxSizing: "border-box", padding: "7px 10px", borderRadius: 6, border: "1px solid #d1d5db", fontSize: 13, resize: "vertical", fontFamily: "inherit", background: "#fff", color: "#111827" }} />
        </div>
      ) : null}

      <div style={{ display: "flex", gap: 8, marginTop: 10, flexWrap: "wrap", alignItems: "center" }}>
        {it.user_phone ? (
          <>
            <a href={wa(it.user_phone)} target="_blank" rel="noreferrer" style={{ ...btn, background: "#22c55e" }}>WhatsApp</a>
            <a href={tel(it.user_phone)} style={{ ...btn, background: "#3b82f6" }}>Call</a>
          </>
        ) : null}
        {done ? (
          <button disabled={busy} onClick={() => onAck(it.id, true)} style={{ ...btn, background: "#9ca3af" }}>Undo</button>
        ) : (
          <>
            <button disabled={saving || busy} onClick={() => saveNote(false)} style={{ ...btn, background: "#6366f1", opacity: note.trim() ? 1 : 0.5 }}>{saving ? "Saving…" : "💾 Save note"}</button>
            <button disabled={saving || busy} onClick={() => saveNote(true)} style={{ ...btn, background: "#111827" }}>✓ Done{note.trim() ? " (save note)" : ""}</button>
            {saved ? <span style={{ color: "#16a34a", fontSize: 12, fontWeight: 600 }}>✓ note saved</span> : null}
          </>
        )}
      </div>
    </div>
  );
}

export default function TeamActionQueue() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState("open");
  const [kind, setKind] = useState("all");
  const [assignee, setAssignee] = useState("all");
  const [search, setSearch] = useState("");

  const load = useCallback(async () => {
    setLoading(true); setErr(null);
    try {
      const qs = `status=${status}&kind=${kind}&assigned_to=${encodeURIComponent(assignee)}&limit=200${search ? `&search=${encodeURIComponent(search)}` : ""}`;
      const res = await ApiRequestNoLoder("GET", `admin/v2/team-action-queue?${qs}`);
      const d = res && res.data ? res.data : res;
      if (d && d.summary) setData(d);
      else setErr((res && res.message) || "Failed to load queue");
    } catch (e) {
      setErr((e && e.message) || "Failed to load");
    } finally {
      setLoading(false);
    }
  }, [status, kind, assignee, search]);

  useEffect(() => { load(); }, [load]);

  const ack = async (forward_id, undo) => {
    setBusy(true);
    try {
      await ApiRequestNoLoder("POST", "admin/v2/team-action-queue/acknowledge", { forward_id, undo });
      await load();
    } catch (e) {
      alert((e && e.message) || "Could not update");
    } finally {
      setBusy(false);
    }
  };

  // Append a note to the member's admin notes (server tags it with the logged-in admin + date).
  const saveNote = async (user_id, instructions) => {
    if (!user_id) throw new Error("This item has no linked profile to note on");
    await ApiRequestNoLoder("POST", "admin/update-user-instructions", { user_id, instructions });
  };

  const s = (data && data.summary) || {};
  const items = (data && data.items) || [];
  const team = (data && data.team_members) || [];
  // Every kind actually present, from the API. This dropdown used to be a hardcoded list of
  // 4 groups while 33 kinds were live, so appointment_time / haan_interest_call /
  // payment_failed / photo_request and the rest were invisible AND unfilterable.
  const kinds = (data && data.kinds) || [];

  const tab = (v, label) => (
    <button onClick={() => setStatus(v)} style={{ ...btn, background: status === v ? "#111827" : "#e5e7eb", color: status === v ? "#fff" : "#374151" }}>{label}</button>
  );
  // Explicit colours: the app's global body colour is near-white, so a select/option with no
  // colour of its own inherits it and renders white-on-white. Options don't inherit the select's
  // colours in Chrome, so both need it.
  const sel = { padding: "7px 10px", borderRadius: 6, border: "1px solid #d1d5db", fontSize: 13, background: "#fff", color: "#111827" };
  const opt = { background: "#fff", color: "#111827" };

  return (
    <div style={{ padding: 20, maxWidth: 1000, margin: "0 auto" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6, flexWrap: "wrap", gap: 8 }}>
        <h1 style={{ fontSize: 24, fontWeight: 800, margin: 0 }}>📋 Team Action Queue</h1>
        <button onClick={load} style={{ ...btn, background: "#111827" }}>Refresh</button>
      </div>
      <p style={{ color: "#6b7280", marginTop: 0 }}>
        Everything the system handed the team to act on — biodata requests, mutual yeses, contact requests, escalations.
        Mark each done once you've acted, so nothing slips.
      </p>

      <div style={{ display: "flex", gap: 10, margin: "12px 0 16px", flexWrap: "wrap" }}>
        <Stat n={s.open_count} label="Open — needs action" color="#ef4444" />
        <Stat n={s.overdue} label="Overdue (24h+)" color="#f59e0b" />
        <Stat n={s.open_hot_leads} label="Mutual yes — introduce" color="#f59e0b" />
        <Stat n={s.open_biodata} label="Biodata asks" color="#8b5cf6" />
        <Stat n={s.open_contact} label="Contact requests" color="#0ea5e9" />
        <Stat n={s.done_count} label="Done" color="#22c55e" />
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap", alignItems: "center" }}>
        {tab("open", "Open")}{tab("done", "Done")}{tab("all", "All")}{tab("stale", "⏰ 24h+")}
        <select value={kind} onChange={(e) => setKind(e.target.value)} style={sel}>
          <option value="all" style={opt}>All types</option>
          {Object.keys(KINDS).map((k) => <option key={k} value={k} style={opt}>{KINDS[k].label}</option>)}
          {kinds.length > 0 && <option disabled style={opt}>----------</option>}
          {kinds.map((k) => (
            <option key={'raw-' + k.kind} value={k.kind} style={opt}>
              {k.kind} ({k.open})
            </option>
          ))}
        </select>
        <select value={assignee} onChange={(e) => setAssignee(e.target.value)} style={sel}>
          <option value="all" style={opt}>All team members</option>
          {team.map((t) => <option key={t.username} value={t.username} style={opt}>{t.username} ({t.open_count} open)</option>)}
        </select>
        <input value={search} onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} placeholder="Search name / phone…" style={{ ...sel, minWidth: 160 }} />
      </div>

      {loading ? <div>Loading…</div> : null}
      {err ? <div style={{ color: "#dc2626" }}>{err}</div> : null}
      {!loading && !err && items.length === 0 ? <div style={{ color: "#9ca3af", fontStyle: "italic", padding: "20px 0" }}>Nothing here — queue is clear. 🎉</div> : null}
      {items.map((it) => <Item key={it.id} it={it} onAck={ack} onNote={saveNote} busy={busy} />)}
    </div>
  );
}
